import { useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import { CSO_SIGNUP } from "../queries";
import LOGO from "../assets/utils/images/originals/logo.png";
import { Link } from "react-router-dom";
import "./csoSignUp.css";

const CSOSignUp = ({ isOpen, onClose, showMessage = false }) => {
  let regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
  const [email, setEmail] = useState("");
  const [isError, setIsError] = useState(false);
  const [isCompleted, setisCompleted] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(null);

  const [csoSignup, { error, data, reset }] = useMutation(CSO_SIGNUP, {
    variables: {
      email,
    },
    onError: () => setIsError(true),
    onCompleted: () => setisCompleted(true),
  });

  const styles = {
    modalTitle: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      gap: "5.5px",
      alignItems: "center",
    },
    header2Style: {
      padding: "1rem 1rem 0 1rem",
      marginBottom: "0.5rem",
    },
  };

  async function signup() {
    try {
      if (!regex.test(email)) return setIsEmailValid(false);
      setIsEmailValid(true);
      await csoSignup();
    } catch (error) {
      console.error(error);
      alert("入力内容に誤りがあります");
    }
  }

  useEffect(() => {
    setIsError(false);
    setisCompleted(false);
    setEmail("");
    setIsEmailValid(null);
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdropClassName="reverted-backdrop"
      className="register-modal"
      style={{ top: "13%" }}
    >
      <ModalBody style={{ padding: "64px 57px", margin: "0px" }}>
        <div style={{ width: "100%", display: "flex" }}>
          <div style={styles["modalTitle"]} className="mb-4">
            <img src={LOGO} alt="socialmap" style={{ width: "40px" }}></img>
            <p
              style={{
                fontSize: "20px",
                fontWeight: 400,
                color: "#000000",
                margin: "0px",
              }}
            >
              個人アカウント作成
            </p>
          </div>
        </div>

        <p style={styles["header2Style"]}>
          個人アカウント登録（無料）で、以下ができるようになります。
        </p>
        <ul className="mb-4">
          <li>CSO（NGO等）の組織情報の詳細を閲覧</li>
          <li>マイページ機能（お気に入りCSOの登録・管理）</li>
          <li>「組織としてアカウント利用」への登録</li>
        </ul>

        {showMessage && (
          <>
            <p style={{ textAlign: "center", marginBottom: "0px" }}>
              サポーターアカウントの作成には
            </p>
            <p style={{ textAlign: "center", marginBottom: "30px" }}>
              個人アカウントの登録が必要です。
            </p>
          </>
        )}

        {isCompleted ? (
          <>
            <p
              style={{
                marginTop: "117px",
                marginBottom: "64px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: 400,
                color: "#000000",
              }}
            >
              送信完了しました。
              <br />
              メールを確認ください。
            </p>
            <p
              style={{
                textAlign: "center",
                fontSize: "14px",
                fontWeight: 400,
                color: "#545FD1",
                cursor: "pointer",
              }}
              onClick={onClose}
            >
              戻る
            </p>
          </>
        ) : (
          <>
            <Form>
              <FormGroup style={{ margin: "0px" }}>
                <Label htmlFor="email">メールアドレス</Label>
                <Input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="example@socialmap.com"
                  style={{ margin: "0px" }}
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                />
              </FormGroup>
              <Button
                className="w-100 mt-2 ema__btn__main__lg"
                style={{ borderRadius: "5px" }}
                onClick={signup}
              >
                送信
              </Button>
            </Form>
            <br />
            <p style={styles["header2Style"]}>
              既に「個人アカウント登録」がお済みの方へ
            </p>
            <ul>
              <li>
                「<a href="/#/pages/login">ログイン</a>」してご利用ください。
              </li>
              <li>
                より詳細な説明は「<a href="/#/dashboards/faq">FAQ</a>
                」をご覧ください。
              </li>
            </ul>

            {isError && (
              <p
                style={{
                  marginTop: "72px",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#FF2626",
                }}
              >
                このアドレスは既に登録されています
              </p>
            )}

            {isEmailValid === false && (
              <p
                style={{
                  marginTop: "72px",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#FF2626",
                }}
              >
                このアドレスは無効です
              </p>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default CSOSignUp;
